module.exports = __webpack_public_path__ + "static/media/japan.c3c4ac96.jpg";